module.exports = __webpack_public_path__ + "static/media/map-outline-01.1eee64de.svg";